import { Renderer, RenderingContext } from "fmko-ts-grid";
import { CertTestCaseVO, TestCaseStatus } from "./RestTypes";

export default class TestCaseResultRenderer implements Renderer {
    public render(ctx: RenderingContext, o: Object) {
        let testCase = <CertTestCaseVO>o;

        if (testCase.error) {
            ctx.text(testCase.error);
        } else if (testCase.status === TestCaseStatus.FINISHED) {
            ctx.html("&#x2713; Godkendt");
        }
    }

    public canRender(o: Object): boolean {
        return true;
    }
}
